import React, { createContext, useContext, useEffect, useState } from 'react';
import Login from './pages/login/Main';
import Main from './pages/layout/main';
import './app.css';
import { getToken, GetData, logOut, getPermission } from './util/auth';
import { getLocalVersion, getCurrentVersion, setLocalVersion, verifyVersion } from './util/version';
import { library } from '@fortawesome/fontawesome-svg-core';

import { faTimes, faBars, faTrash, faTachometerAlt,faLock, faChartLine,faFolderPlus,faArchive, faSignOutAlt, faChevronDown, faPoll, faEdit, faClipboardList, faFolder } from "@fortawesome/free-solid-svg-icons";
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from "react-router-dom";
//----------------------------------------------------------------
import Dashboard from './pages/Dashboard/Main';
import { VtaInvValDrot, DnSsnDp, Prices, Visibility, AmplitudeSkuMarca, AmplitudeAttribute, BrandOverlapping, Coexistence, Distribution, DistributionSummary, DistributionWeighted, MultiCoexistence, PriceHistRecord, PriceHistogram, PricePromModa, ProjectMASS, Purchase, ShareShopping, ValuedPurchase, GenerateData, VtaResInvValDrot } from './pages/reports/index';
import { Customer } from './pages/administration';
import { MainTab, Base, PurchInvt } from './pages/analysis';
//----------------------------------------------------------------

import Request from './pages/poll/Request';
import Planning from './pages/poll/Planning';


library.add(faTimes, faBars, faTachometerAlt, faChartLine, faLock,faFolderPlus,faArchive, faSignOutAlt, faChevronDown, faPoll, faEdit, faTrash, faClipboardList, faFolder)

const App = () => {

    const localVersion = getLocalVersion();
    const currentVersion = getCurrentVersion();

    if (localVersion === undefined) {
        setLocalVersion(currentVersion);
        logOut();
    } else {
        const verif = verifyVersion();
        if (!verif) {
            logOut();
            setLocalVersion(currentVersion);
        }
    }

    return (
        <AuthProvider>
            <Router basename="">
                <Routes>
                    <Route path="/" element={<RequiredAuth><Main></Main></RequiredAuth>}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="reportes">
                            <Route path="auditoria">
                                <Route path="consumo-inventario-drot" element={<AuditPermission><VtaInvValDrot /></AuditPermission>} />
                                <Route path="distribucion-numerica-ponderada-sin-stock" element={<AuditPermission><DnSsnDp /></AuditPermission>} />
                                <Route path="precio-moda-promedio" element={<AuditPermission><Prices /></AuditPermission>} />
                                <Route path="consumo-resumen-inventario-drot" element={<AuditPermission><VtaResInvValDrot /></AuditPermission>} />
                            </Route>
                            <Route path="chequeos">
                                <Route path='distribucion' element={<ChequeoPermission><Distribution /></ChequeoPermission>} />
                                <Route path='proyecto-mass' element={<ChequeoPermission><ProjectMASS /></ChequeoPermission>} />
                                <Route path='distribucion-ponderada' element={<ChequeoPermission><DistributionWeighted /></ChequeoPermission>} />
                                <Route path='share-de-compras' element={<ChequeoPermission><ShareShopping /></ChequeoPermission>} />
                                <Route path='visibilidad' element={<ChequeoPermission><Visibility /></ChequeoPermission>} />
                                <Route path='compra' element={<ChequeoPermission><Purchase /></ChequeoPermission>} />
                                <Route path='compra-valorizada' element={<ChequeoPermission><ValuedPurchase /></ChequeoPermission>} />
                                <Route path='precio-promedio-moda' element={<ChequeoPermission><PricePromModa /></ChequeoPermission>} />
                                <Route path='convivencia' element={<ChequeoPermission><Coexistence /></ChequeoPermission>} />
                                <Route path='multi-convivencia' element={<ChequeoPermission><MultiCoexistence /></ChequeoPermission>} />
                                <Route path='resumen-distribucion' element={<ChequeoPermission><DistributionSummary /></ChequeoPermission>} />
                                <Route path='histograma-precios' element={<ChequeoPermission><PriceHistogram /></ChequeoPermission>} />
                                <Route path='histograma-precios-registro' element={<ChequeoPermission><PriceHistRecord /></ChequeoPermission>} />
                                <Route path='sobreposicion-marcas' element={<ChequeoPermission><BrandOverlapping /></ChequeoPermission>} />
                                <Route path='amplitud-sku-marcas' element={<ChequeoPermission><AmplitudeSkuMarca /></ChequeoPermission>} />
                            </Route>
                        </Route>
                        <Route path="reportes-interno">
                            <Route path="auditoria">
                                <Route path="consumo-inventario-drot" element={<AuditInternoPermission><VtaInvValDrot test={3} /></AuditInternoPermission>} />
                                {/* Se esta poniendo 3 para pruebas V2*/}
                                <Route path="distribucion-numerica-ponderada-sin-stock" element={<AuditInternoPermission><DnSsnDp test={3} /></AuditInternoPermission>} />
                                <Route path="precio-moda-promedio" element={<Prices test={1} />} />
                                <Route path="generar-data" element={<GenerateData test={2} />} />
                                <Route path="consumo-resumen-inventario-drot" element={<VtaResInvValDrot test={1} />} />
                            </Route>

                            <Route path="chequeos">
                                <Route path='distribucion' element={<ChequeoPermission><Distribution test={1} /></ChequeoPermission>} />
                                <Route path='proyecto-mass' element={<ChequeoPermission><ProjectMASS test={1} /></ChequeoPermission>} />
                                <Route path='distribucion-ponderada' element={<ChequeoPermission><DistributionWeighted test={1} /></ChequeoPermission>} />
                                <Route path='share-de-compras' element={<ChequeoPermission><ShareShopping test={1} /></ChequeoPermission>} />
                                <Route path='visibilidad' element={<ChequeoPermission><Visibility test={1} /></ChequeoPermission>} />
                                <Route path='compra' element={<ChequeoPermission><Purchase test={1} /></ChequeoPermission>} />
                                <Route path='compra-valorizada' element={<ChequeoPermission><ValuedPurchase test={1} /></ChequeoPermission>} />
                                <Route path='precio-promedio-moda' element={<ChequeoPermission><PricePromModa test={1} /></ChequeoPermission>} />
                                <Route path='convivencia' element={<ChequeoPermission><Coexistence test={1} /></ChequeoPermission>} />
                                <Route path='multi-convivencia' element={<ChequeoPermission><MultiCoexistence test={1} /></ChequeoPermission>} />
                                <Route path='resumen-distribucion' element={<ChequeoPermission><DistributionSummary test={1} /></ChequeoPermission>} />
                                <Route path='histograma-precios' element={<ChequeoPermission><PriceHistogram test={1} /></ChequeoPermission>} />
                                <Route path='histograma-precios-registro' element={<ChequeoPermission><PriceHistRecord test={1} /></ChequeoPermission>} />
                                <Route path='sobreposicion-marcas' element={<ChequeoPermission><BrandOverlapping test={1} /></ChequeoPermission>} />
                                <Route path='amplitud-sku-marcas' element={<ChequeoPermission><AmplitudeSkuMarca test={1} /></ChequeoPermission>} />
                                <Route path='amplitud-atributos' element={<ChequeoPermission><AmplitudeAttribute test={1} /></ChequeoPermission>} />
                            </Route>
                        </Route>
                        <Route path="administracion">
                            <Route path='customer' element={<Customer />} />
                        </Route>
                        <Route path='encuesta'>
                            <Route path='consulta' element={<Request />} />
                            <Route path='planificacion' element={<Planning />} />
                        </Route>
                        <Route path='analisis'>
                            <Route path='muestras' element={<MainTab />} />
                            <Route path='base' element={<Base />} />
                            <Route path='compra-inventario' element={<PurchInvt />} />
                        </Route>
                    </Route>
                    <Route path="login" element={<Login />} />
                </Routes>
            </Router>
        </AuthProvider>
    )
}


let AuthContext = createContext(null);
const useAuth = () => {
    return useContext(AuthContext);
}
const AuthProvider = (props) => {
    let [token, setToken] = useState(getToken())
    let [user, setUser] = useState(null);

    const setValueToken = (val) => {
        setToken(val)
    }
    const setValueUser = (val) => {
        setUser(val)
    }

    useEffect(() => {
        setToken(getToken())
        GetData().then(data => setUser(data));
    }, []);
    let value = { user, token, setValueToken, setValueUser };
    return (
        <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>
    )
}

const RequiredAuth = (props) => {
    let auth = useAuth();
    let location = useLocation();
    if (auth.user === 'error' || auth.token === undefined || auth.token === '' || auth.token === null) {
        //ahora a pensar como mandar la funcion a las paginas
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return props.children;
}

const ChequeoPermission = (props) => {
    const p = []
    const per = getPermission().permissions;
    for (let m = 0; m < per.length; m++) {
        p.push(getPermission().permissions[m]['code']);
    }
    let location = useLocation();
    if (p.indexOf('VIEW_MOD_CHEQUEO_REPORT') < 0) {
        return <Navigate to="/dashboard" state={{ from: location }} replace />;
    }
    return props.children;
}

const AuditPermission = (props) => {
    const p = []
    const per = getPermission().permissions;
    for (let m = 0; m < per.length; m++) {
        p.push(getPermission().permissions[m]['code']);
    }
    let location = useLocation();
    if (p.indexOf('VIEW_MOD_AUDIT_REPORT') < 0) {
        return <Navigate to="/dashboard" state={{ from: location }} replace />;
    }
    return props.children
}

const AuditInternoPermission = (props) => {
    const p = []
    const per = getPermission().permissions;
    for (let m = 0; m < per.length; m++) {
        p.push(getPermission().permissions[m]['code']);
    }
    let location = useLocation();
    if (p.indexOf('VIEW_MOD_AUDIT_REPORT_INTERNAL') < 0) {
        return <Navigate to="/dashboard" state={{ from: location }} replace />;
    }
    return props.children
}
const AdminPermission = (props) => {
    const p = []
    const per = getPermission().permissions;
    for (let m = 0; m < per.length; m++) {
        p.push(getPermission().permissions[m]['code']);
    }
    let location = useLocation();
    if (p.indexOf('VIEW_MOD_ADM') < 0) {
        return <Navigate to="/dashboard" state={{ from: location }} replace />;
    }
    return props.children
}

export default App;